import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import TwistLockConfigListing from './TwistLockConfigListing'
import TwistLockCredentialsForm from './TwistLockCredentialsForm'

export default function TwistLockPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={TwistLockCredentialsForm}
            PullConfigListingView={TwistLockConfigListing}
        />
    )
}
